import HeartDollarIcon from 'components/assets/dollar-heart.svg';
import CardWithTitle from 'components/atoms/Card/CardWithTitle';
import Currency from 'components/atoms/Currency/Currency';
import Txt from 'components/atoms/Txt/Txt';
import { LifetimeReferralsStats_referralsRef$key } from 'components/organisms/LifetimeReferralsStats/__generated__/LifetimeReferralsStats_referralsRef.graphql';
import { graphql, useFragment } from 'react-relay';
import classes from './LifetimeReferralsStats.module.scss';

export type Props = {
  referralsRef: LifetimeReferralsStats_referralsRef$key;
};

export default function LifetimeReferralsStats({ referralsRef }: Props) {
  const data = useFragment<LifetimeReferralsStats_referralsRef$key>(
    graphql`
      fragment LifetimeReferralsStats_referralsRef on ReferralHistory {
        lifetime {
          successes
          earnings {
            subUnitAmount
            currency
          }
        }
      }
    `,
    referralsRef,
  );

  return (
    <CardWithTitle title="Reward History">
      <div className={classes.root}>
        <div className={classes.count}>
          <Txt className={classes.title}>Lifetime Paid Referrals</Txt>
          <div>
            <HeartDollarIcon className={classes.icon} />
            <span className={classes.value}>{data.lifetime.successes}</span>
          </div>
        </div>
        <div className={classes.earnings}>
          <Txt className={classes.title}>Lifetime Earnings</Txt>
          <Currency
            amount={(data.lifetime.earnings?.subUnitAmount ?? 0) / 100}
            currency={data.lifetime.earnings?.currency ?? 'USD'}
            className={classes.value}
            options={{
              maximumFractionDigits: 2,
              minimumFractionDigits: 0,
            }}
          />
        </div>
      </div>
    </CardWithTitle>
  );
}
